import {Dispatch, ThunkAction} from 'app/types/actions';
import { SegmentCardEvent, segmentTrackAction } from 'app/middlewares/segment';

export const onEsc = (
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
    ) => {
        dispatch(segmentTrackAction(SegmentCardEvent.ESCAPE_NAME_CHANGE));
    };
    return action;
};
